// import { tr } from "date-fns/locale";

const RotateIcon = function(options) {
    this.options = options || {};
    this.rImg = options.img || new Image();
    this.rImg.src = this.rImg.src || this.options.url || '';
    this.options.width = this.options.width || 52;
    this.options.height = this.options.height || 60;
    this._canvas = null;
    this._context = null;
    this._hasDrawn = false;
  };
  RotateIcon.makeIcon = function(url) {
    return new RotateIcon({ url: url });
  };
  
  RotateIcon.prototype.setRotation = function (options) {
    const angle = options.deg ? (options.deg * Math.PI) / 180 : options.rad;
    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));

    // Scale down với height giảm nhiều hơn width
    const scaleWidth = 0.65;
    const scaleHeight = 0.55;
    const targetWidth = this.options.width * scaleWidth;
    const targetHeight = this.options.height * scaleHeight;

    // Tính bounding box theo góc xoay
    const newWidth = targetWidth * cos + targetHeight * sin;
    const newHeight = targetWidth * sin + targetHeight * cos;

    if (!this._canvas) {
      this._canvas = document.createElement('canvas');
    }
    this._canvas.width = newWidth;
    this._canvas.height = newHeight;

    const ctx = this._canvas.getContext("2d");
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';

    ctx.clearRect(0, 0, newWidth, newHeight);

    ctx.save();
    ctx.translate(newWidth / 2, newHeight / 2);
    ctx.rotate(angle);
    ctx.translate(-targetWidth / 2, -targetHeight / 2);

    const draw = () => {
      ctx.drawImage(this.rImg, 0, 0, targetWidth, targetHeight);
      ctx.restore();
      this._hasDrawn = true;
    };

    if (this.rImg.complete) {
      draw();
    } else {
      this.rImg.onload = draw;
    }

    return this;
};

RotateIcon.prototype.getUrl = function () {
  if (!this._hasDrawn) {
    this.setRotation({ deg: 0 });
  }
  return this._canvas.toDataURL();
};

RotateIcon.prototype.getSize = function () {
  if (!this._hasDrawn) {
    this.setRotation({ deg: 0 });
  }
  return [this._canvas.width, this._canvas.height];
};

export default RotateIcon;
